import React from 'react';
import { Layout, Menu } from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import {
    NotificationOutlined,
    SettingOutlined,
    UserOutlined,
    ReconciliationOutlined,
    DashboardOutlined,
    FileTextOutlined,
} from '@ant-design/icons';

const { Sider } = Layout;

export const SiderProfile = () => {
    const history = useHistory();
    const location = useLocation();

    const handleNavigateSider = (index: string) => {
        if (index === '1') {
            history.push('/profile/assets');
        } else if (index === '2') {
            history.push('/profile/orders');
        } else if (index === '3') {
            history.push('/profile');
        } else if (index === '4') {
            history.push('/profile/notifications');
        } else if (index === '5') {
            history.push('/profile/settings');
        } else if (index === '6') {
            history.push('/profile/inventory');
        }
    };
    const selectedKey = (() => {
        if (/^\/profile\/assets/.test(location.pathname)) return '1';
        if (/^\/profile\/orders/.test(location.pathname)) return '2';
        if (/^\/profile\/?$/.test(location.pathname)) return '3';
        if (/^\/profile\/notifications/.test(location.pathname)) return '4';
        if (/^\/profile\/settings/.test(location.pathname)) return '5';
        if (/^\/profile\/inventory/.test(location.pathname)) return '6';
        return '';
    })();

    return (
        <Sider className="pg-profile-page_layout__sider" width={250} data-tour="profile-sidebar">
            <Menu
                selectedKeys={[selectedKey]}
                className="pg-profile-page_sider__menu"
                onClick={(info) => handleNavigateSider(info.key)}>
                <Menu.Item key="1" data-tour="profile-assets-menu">
                    <DashboardOutlined /> Assets Overview
                </Menu.Item>
                <Menu.Item key="6" data-tour="profile-inventory-menu">
                    <FileTextOutlined /> Inventory
                </Menu.Item>
                <Menu.Item key="2" data-tour="profile-orders-menu">
                    <ReconciliationOutlined /> Order Management
                </Menu.Item>
                <Menu.Item key="3" data-tour="profile-info-menu">
                    <UserOutlined /> Profile
                </Menu.Item>
                <Menu.Item key="4" data-tour="profile-notifications-menu">
                    <NotificationOutlined /> Notifications
                </Menu.Item>
                <Menu.Item key="5" data-tour="profile-settings-menu">
                    <SettingOutlined /> Settings
                </Menu.Item>
            </Menu>
        </Sider>
    );
};
